import Request from '@/utils/request'

// newguy充值活动
export function apiAct(params) {
  return Request({
    url: '/api/v2/app/shop/activity/27/cfg',
    method: 'get',
    params,
  })
}

export function apiDraw() {
  return Request({
    url: '/api/v2/app/shop/activity/27/draw',
    method: 'post',
  })
}
